function text(value) {
  return String(value ?? '').trim();
}

function artifactStatusKey(item = {}) {
  if (item?.type !== 'message_artifact') {
    return '';
  }
  if (item.presentation_kind === 'committed_artifact') return text(item.id);
  const targetTab = text(item.target_tab);
  const artifactType = normalizeArtifactType({
    artifactType: text(item.artifact_type),
    targetTab,
  });
  if (targetTab || artifactType) {
    return [targetTab || 'artifact', artifactType || 'document'].join(':');
  }
  return text(item.artifact_id);
}

function normalizeArtifactType({ artifactType, targetTab }) {
  if (targetTab !== 'analysis') {
    return artifactType;
  }
  if (['analysis_report', 'report', 'plan'].includes(artifactType)) {
    return 'analysis_report';
  }
  return artifactType;
}

export function collapseArtifactStatusItems(items = []) {
  const source = Array.isArray(items) ? items : [];
  const committed = source.filter((item) => item.presentation_kind === 'committed_artifact');
  const latestIndexByKey = new Map();
  source.forEach((item, index) => {
    const key = artifactStatusKey(item);
    if (key) {
      latestIndexByKey.set(key, index);
    }
  });
  return source.filter((item, index) => {
    if (item.type === 'message_artifact' && item.presentation_kind !== 'committed_artifact'
      && committed.some((card) => card.roundKey === item.roundKey && card.artifact_id === item.artifact_id)) return false;
    const key = artifactStatusKey(item);
    return !key || latestIndexByKey.get(key) === index;
  });
}

export default collapseArtifactStatusItems;
